module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Pheng-Chew-7ddfb8767c64091b70642ba6cda28b7b.jpg";